import qc from 'qc'
import _ from 'lodash'
import { scripts } from '@ps/bridge/qc/scripts/index'

export interface MovieClipScript {
  // 当前序列帧 action name
  defActionName: string
  playTime: number
  interval: number
  autoDestory: boolean
  pingpong: boolean
  defPlay: boolean
  data: {
    // 所有 bin 文件路径
    allFramePlaySmart: string
    [key: string]: string
  }
  initData: () => unknown
  gotoAndPlay: () => unknown // todo：参数以后补
  isPlaying: boolean // 当前是否播放状态
  actionNames?: Record<string, string | number> // 自研素材兼容
  path: string
  mcData: Record<
    string,
    { frameName: string; action: string; frameCnt: number }
  >
}

/**
 * ps.MovieClipScript 脚本在编辑与线上运行的时候都会加载进去
 */
export const getScript = (
  node: qc.Node,
  addScriptIfScriptNotExist = true,
): MovieClipScript | undefined => {
  const config: MovieClipScript = node.getScript(scripts.movieClip.name)
  if (config) {
    return config
  }
  if (addScriptIfScriptNotExist) {
    return node.addScript(scripts.movieClip.name) as MovieClipScript
  }
}

/**
 * 给节点指定 action 添加图片
 * @param node 节点
 * @param actionName action 名字
 * @param images 指定 action 需要新增的图片
 */
export const addImageToTargetAction = ({
  node,
  actionName,
  images,
}: {
  node: qc.Node
  actionName: string
  images: string[]
}): MovieClipScript | undefined => {
  const mv: MovieClipScript = getScript(node) as MovieClipScript

  if (!mv) return
  // 当前当前图片列表
  const currentActionBinList = [
    ...(mv.data[actionName] || '').split(','),
    ...images,
  ].filter((bin) => Boolean(bin))
  mv.data[actionName] = currentActionBinList.join(',')
  // 更新所有图片，需要去重（但是当前action的不需要去重，因为可以使用相同的资源）
  mv.data.allFramePlaySmart = _.uniq(
    [...(mv.data.allFramePlaySmart || '').split(','), ...images].filter((bin) =>
      Boolean(bin),
    ),
  ).join(',')
  mv.initData()
  return mv
}

/**
 * 更新节点 MovieClipScript 的指定 action
 * @param node 节点
 * @param actionName action 名字
 * @param images 指定 action 的图片
 * @param allImages 所有 action 使用的图片
 */
export const updateTargetActionBin = ({
  node,
  actionName,
  images,
  allImages,
}: {
  actionName: string
  images: string // 当前 action 图片
  node: qc.Node
  allImages?: string // 所有图片
}): MovieClipScript | undefined => {
  const mv = getScript(node) as MovieClipScript

  if (!mv) return

  mv.data[actionName] = images // 如果 mv.data[actionName] 是响应式的，如果在 vue 中使用也能够触发到界面的 UI 更新
  allImages && (mv.data.allFramePlaySmart = allImages)
  mv.initData()
  return mv
}

/**
 * 获取所有 bin 文件列表
 */
export const getAllBinFiles = (node: qc.Node): string | void => {
  const script = getScript(node)
  if (script) {
    return _.get(script, `[data][allFramePlaySmart]`)
  }
}

/**
 * 设置所有 bin 文件列表
 */
export const setAllBinFiles = (node: qc.Node, binFiles: string): void => {
  const script = getScript(node)
  if (script) {
    script.data.allFramePlaySmart = binFiles
  }
}

/**
 * 获取当前 action 的 bin 文件列表
 */
export const getCurrentActionBinFiles = (node: qc.Node): string | void => {
  const script = getScript(node)
  if (script) {
    return _.get(script, `[data][${script.defActionName}]`)
  }
}

/**
 * 设置当前 action 的 bin 文件列表
 */
export const setCurrentActionBinFiles = (
  node: qc.Node,
  binFiles: string,
): void => {
  const script = getScript(node)
  if (script) {
    script.data[script.defActionName] = binFiles
  }
}
/**
 * 自研项目的MovieClip没有data,需要从actionNames中解析出来
 * @param node 节点
 */
export const fixMovieClipData = (node: qc.Node): void => {
  const mv: MovieClipScript = getScript(node) as MovieClipScript
  if (
    (_.isEmpty(mv.data) && !_.isEmpty(mv.actionNames)) ||
    (mv.data && mv.data.frame)
  ) {
    if (!mv.data) {
      mv.data = { allFramePlaySmart: '' }
    }
    const actionNames = mv.actionNames
    const path = mv.path
    const totalUrls: string[] = []
    if (actionNames) {
      Object.keys(actionNames).forEach((key) => {
        const value = actionNames[key]
        const arr = []
        for (let i = 1; i <= Number(value); i++) {
          const mcData = mv.mcData
          const mcDataItem = mcData && mcData[key]
          let url = ''
          if (mcDataItem) {
            url = mcDataItem.frameName.replace('{0}', i.toString())
          } else {
            url = `${path}/${key}_${i}.bin`
          }
          arr.push(url)
          totalUrls.push(url)
        }
        mv.data[key] = arr.join(',')
      })
    }
    mv.data['allFramePlaySmart'] = totalUrls.join(',')
  }
}
